import * as React from 'react'

import { HouseIcon } from 'lucide-react'

import { GenericWorkflowIcon } from '~/client/src/shared/components/WorkflowTypeIcon/WorkflowIconGroups'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import QRCodeRenderer from './QRCodeRenderer'

interface IQRsToPrintProps {
  homeUrl: string
  formsUrl: string
  isFormsDisabled: boolean
  isLogisticsDisabled: boolean
  homeRef: (element: HTMLDivElement | null) => void
  formsRef: (element: HTMLDivElement | null) => void
}

const QRsToPrint: React.FC<IQRsToPrintProps> = ({
  homeUrl,
  formsUrl,
  isFormsDisabled,
  isLogisticsDisabled,
  homeRef,
  formsRef,
}) => {
  return (
    <>
      {!isLogisticsDisabled && (
        <div className="hidden">
          <div ref={homeRef} className="qr-code-to-print-holder">
            <QRCodeRenderer
              url={homeUrl}
              caption={Localization.translator.struxHubHome}
              icon={
                <HouseIcon size={24} className="tw:flex-none! tw:text-black" />
              }
            />
          </div>
        </div>
      )}
      {!isFormsDisabled && (
        <div className="hidden">
          <div ref={formsRef} className="qr-code-to-print-holder">
            <QRCodeRenderer
              url={formsUrl}
              caption={Localization.translator.struxHubForms}
              icon={<GenericWorkflowIcon className="tw:flex-none!" />}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default QRsToPrint
